import React, { useEffect, useState, useRef } from "react";
import Navbar from "../components/Navbar";
import Footer from "../Footer";
import { Link } from "react-router-dom";
import axios from "axios";
import { toTitleCase } from "../helper/formatCarName";
import { SkeletonCard } from "../components/SkeletonLoader";
import CarCard from "../components/CarCard";

const RejectedRequest = () => {
  const [rejectList, setRejectList] = useState([]);
  const [selectId, setSelectId] = useState();
  const [userId, setUserId] = useState();
  const [isProcess, setIsProcess] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);
  const buttonRef = useRef(null);

  const acceptRejectBid = async (id, status) => {
    setIsProcess(true);
    try {
      const response = await axios.post(
        window.CARLOCA_API + "/status/bidding",
        {
          user_id: userId,
          bid_id: id,
          status: status,
        }
      );
      setIsProcess(false);
      if (buttonRef.current) {
        buttonRef.current.click();
      }
      fetchData();
    } catch (error) {
      console.error("An error occurred while fetching data.", error);
    }
  };

  const getDataFromlocalStorage = (key) => {
    try {
      const serializedData = localStorage.getItem(key);
      return serializedData ? JSON.parse(serializedData) : null;
    } catch (error) {
      console.error("Error getting data from localStorage:", error);
      return null;
    }
  };
  const storedUserPreferences = getDataFromlocalStorage("userData");

  const fetchData = async () => {
    try {
      const response = await axios.post(
        window.CARLOCA_API + "/get/owner/bids",
        {
          owner_id: storedUserPreferences?.id,
        }
      );
      const filteredData = response?.data.biddings.filter(
        (item) => item.status === "reject" && item.isDelete=="0"
      );

      setRejectList(filteredData);
    } catch (error) {
      console.error("An error occurred while fetching data.", error);
    } finally {
      setPageLoading(false);
    }
  };
  const deleteBid = async (id, userId) => {
    if (window.confirm("Do you realy want to delete this accepted offer!")) {
      try {
        const response = await axios.post(
          window.CARLOCA_API + "/remove/bid",
          {
            owner_id: userId,
            bid_id: id,
          }
        );
        fetchData();
      } catch (error) {
        console.log("An error occurred while fetching data.", error);
      }
    }
  };
  function formatEuroAmount(amount) {
    const parts = amount.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  }
  useEffect(() => {
    fetchData();
  }, []);

  function backto() {
    window.history.back();
  }
  return (
    <>
      <Navbar />
      <div className="cl-page">
        <div className="container">
          <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
            <div>
              <h3 className="cl-page-title">Rejected Offers</h3>
              <p className="cl-page-subtitle">Offers that have been rejected</p>
            </div>
            <button onClick={backto} type="button" className="cl-btn cl-btn-outline cl-btn-sm">
              <i className="fa fa-arrow-left me-1"></i>Back
            </button>
          </div>
          <div className="row g-3">
            {pageLoading ? (
              <SkeletonCard count={8} />
            ) : rejectList?.length === 0 ? (
              <div className="cl-empty">
                <div className="cl-empty-icon"><i className="fa-solid fa-ban"></i></div>
                <h6 className="cl-empty-title">No Rejected Offers</h6>
                <p className="cl-empty-text">No offers have been rejected.</p>
              </div>
            ) : (
            rejectList?.map((car) => (
              <div
                key={car?.id}
                className="col-xxl-3 col-xl-3 col-lg-4 col-md-4 col-sm-6 col-6"
              >
                <CarCard
                  carData={car?.car}
                  topLeftContent={
                    <button
                      className="btn btn-sm btn-danger"
                      style={{ border: "none", cursor: "pointer", borderRadius: "6px", padding: "4px 8px" }}
                      onClick={(e) => { e.preventDefault(); e.stopPropagation(); deleteBid(car.id, car.bidder?.id); }}
                    >
                      <i className="fa fa-trash" style={{ color: "white", fontSize: "13px" }}></i>
                    </button>
                  }
                  extraBodyContent={
                    <div className="mt-1 pt-1" style={{ borderTop: "1px solid #e5e7eb" }}>
                      <div className="d-flex justify-content-between align-items-center mb-1">
                        <span style={{ fontSize: "11px", color: "#6b7280" }}>From</span>
                        <span className="fw-semibold text-truncate text-end" style={{ fontSize: "11px", color: "#00889c", maxWidth: "55%" }}>
                          {car.bidder.role === "dealer"
                            ? "Dealer"
                            : car.bidder.role === "user"
                            ? car.bidder.first_name
                            : null}
                        </span>
                      </div>
                      <div className="d-flex justify-content-between align-items-center mb-1">
                        <span style={{ fontSize: "11px", color: "#6b7280" }}>Offer</span>
                        <span className="fw-bold text-truncate text-end" style={{ fontSize: "12px", color: "#00889c", maxWidth: "55%" }}>£{formatEuroAmount(car.amount)}</span>
                      </div>
                      <div className="d-flex justify-content-between align-items-center mb-1">
                        <span style={{ fontSize: "11px", color: "#6b7280" }}>Request</span>
                        <span className="fw-semibold text-capitalize text-truncate text-end" style={{ fontSize: "10px", color: "#00889c", maxWidth: "55%" }}>{car.bid_request}</span>
                      </div>
                      <button
                        style={{ fontSize: "10px", padding: "4px", background: "linear-gradient(135deg, #00889c, #006f80)", border: "none", borderRadius: "6px" }}
                        className="btn btn-sm text-white w-100 mt-1"
                        data-bs-toggle="modal"
                        onClick={(e) => {
                          e.preventDefault(); e.stopPropagation();
                          setSelectId(car.id);
                          setUserId(car?.user_id);
                        }}
                        data-bs-target="#exampleModal1"
                      >
                        <i className="fa-solid fa-check me-1"></i>Accept Communication
                      </button>
                    </div>
                  }
                  hideFooter={true}
                />
              </div>
            ))
            )}
          </div>
        </div>
      </div>
        {/* Accept offer popup */}
        <div
          className="modal fade "
          id="exampleModal1"
          tabIndex="-1"
          aria-labelledby="exampleModalLabel1"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-body text-center mt-3 small_modal">
                <h5 className="">
                  Are you sure you want to accept this request?
                </h5>

                {/* <h4 className='blue'>£65000</h4> */}
                <div className="d-flex justify-content-center mt-3">
                  <button
                    onClick={() => acceptRejectBid(selectId, "again-accept")}
                    className="btn btn-primary btn-sm mx-2"
                    // data-bs-dismiss="modal"
                    disabled={isProcess}
                  >
                    {isProcess ? "Processing..." : "Yes"}
                  </button>
                  <button
                    className="btn btn-danger btn-sm mx-2"
                    data-bs-dismiss="modal"
                  >
                    No
                  </button>
                </div>
              </div>
              <div className="modal-footer border-0">
                <button
                  ref={buttonRef}
                  className="btn btn-secondary btn-sm d-none"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Deny offer popup */}
        <div
          className="modal fade"
          id="exampleModal2"
          tabIndex="-1"
          aria-labelledby="exampleModalLabel2"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-body text-center mt-3 small_modal">
                <h5 className="">
                  Are you sure you want to deny this request?
                </h5>
                {/* <h4 className='blue'>£65000</h4> */}
                <div className="d-flex justify-content-center mt-3">
                  <button
                    onClick={() => acceptRejectBid(selectId, "reject")}
                    className="btn btn-primary btn-sm mx-2"
                    data-bs-dismiss="modal"
                  >
                    Yes
                  </button>
                  <button
                    className="btn btn-danger btn-sm mx-2"
                    data-bs-dismiss="modal"
                  >
                    No
                  </button>
                </div>
              </div>
              <div className="modal-footer border-0">
                <button
                  type="button"
                  className="btn btn-secondary btn-sm"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>

        <Footer />
    </>
  );
};

export default RejectedRequest;
